










































































































































































































































































































































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { CoreStoreState } from '@/core';
import { RootStoreState } from '@/store';
import {
  SwModal,
  SwModalBody,
  SwModalFooter,
} from '@libs-uuif/shared/sw-modal';
import { SwRadio } from '@libs-uuif/shared/sw-radio';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwStatusInfo } from '@libs-uuif/shared/sw-status-info';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { SwSelect, SelectOption } from '@libs-uuif/shared/sw-select';
import { SwForm, SwFormRow, SwFormRowError } from '@libs-uuif/shared/sw-form';
import {
  SwTextfield,
  SwExpandableTextfield,
} from '@libs-uuif/shared/sw-textfield';
import {
  ValidationGroupConfig,
  validationService,
  validationType,
  ValidationErrorObj,
} from '@sonicwall/unified-ui-framework/src/shared/validation-service';
import { SwBlockingProgress } from '@libs-uuif/shared/sw-blocking-progress';
import {
  messageService,
  SwMessageContainer,
} from '@libs-uuif/shared/message-service';
import {
  selectIntervalOptions,
  selectFrequencyOptions,
  selectWeeklyOptions,
  selectMonthlyOptions,
  selectNsmMonthlyOptions,
  selectReportPeriodOptions,
  selectTimeOptions,
  ccScheduledPostData,
  ccOnDemandPostData,
  nsmScheduledPostData,
  archiveConfig,
  emailConfig,
  // scheduleWireless,
  selectProductTabs,
} from '../report-constants';
import { confirmService } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import {
  SwTabGroup,
  SwTabPage,
} from '@libs-uuif/shared/sw-tab-layout';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { unifiedInsightsApiService } from '@/shared/api-service/unified-insights-api-wrapper';
import { unifiedMessageContainer } from '@/shared/constants';
import { SwActionBar, SwActionBarItem } from '@libs-uuif/shared/sw-action-bar';
import captureClientReport from './sw-capture-client-reports.vue';
import firewallReport from './sw-firewall-reports.vue';
import wirelessReport from './sw-wireless-reports.vue';
import {
  localStorageKeeperService,
  sessionStorageKeeperService,
} from '@/shared/auth-service';
import axios from 'axios';
import _ from 'lodash';
import { wcmApiService } from '@/shared/api-service/wcm-api-service';
import { UnifiedInsightsReportsStoreState } from './../unified-insights-reports.store';

const cssPrefix = 'sw-create-edit-report';

@Component({
  components: {
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwRadio,
    SwSelect,
    SwForm,
    SwFormRow,
    SwFormRowError,
    SwTextfield,
    SwCheckbox,
    SwMessageContainer,
    SwButton,
    SwBlockingProgress,
    SwStatusInfo,
    SwIcon,
    SwActionBar,
    SwActionBarItem,
    SwExpandableTextfield,
    captureClientReport,
    firewallReport,
    wirelessReport,
    SwTabGroup,
    SwTabPage,
  },
  directives: {
    tooltip,
  },
})
export default class SwCreateEditReport extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @State((state: RootStoreState) => state.CoreStoreModule.tenantName)
  readonly tenantName: CoreStoreState['tenantName'];

  @State((state: RootStoreState) => state.CoreStoreModule.tenantGroups)
  readonly tenantGroups: CoreStoreState['tenantGroups'];

  @State((state: RootStoreState) => state.UnifiedInsightsReportsStoreModule.totalWcmOnDemandReports)
  readonly totalWcmOnDemandReports: UnifiedInsightsReportsStoreState['totalWcmOnDemandReports'];

  @State((state: RootStoreState) => state.CoreStoreModule.productList)
  productList: CoreStoreState['productList'];

  @Prop({ type: Boolean, required: true, default: false })
  openModal: boolean;

  @Prop({ type: Array, required: false, default: false })
  editReportData: any[];

  @Prop({ type: Boolean, required: true, default: false })
  isReportEdit: boolean;

  @State((state: RootStoreState) => state.CoreStoreModule.nsmBaseUrl)
  nsmBaseUrl: CoreStoreState['nsmBaseUrl'];

  @State((state: RootStoreState) => state.CoreStoreModule.ccBaseUrl)
  ccBaseUrl: CoreStoreState['ccBaseUrl'];

  @State((state: RootStoreState) => state.CoreStoreModule.nsmTenentID)
  readonly nsmTenentID: CoreStoreState['nsmTenentID'];

  display: boolean = false;
  showMsg: boolean = false;
  showEmailMsg: boolean = false;
  showMailError: boolean = false;
  disableReportType: boolean = false;
  isEditUnable: boolean = false;
  isLoading: boolean = false;
  closedEditModal: boolean = false;
  isInnerReportData: boolean = true;
  disableSaveButton: boolean = false;
  disabledEmailField: boolean = false;
  errorsObj: ValidationErrorObj = {};
  reportType: string = 'ondemand_report';
  reportName: string = '';
  emailAddress: string = '';
  selectRange: number = 0;
  reportDescription: string = '';
  selectOptions: SelectOption[] = [
    {
      id: 'All groups',
      label: 'All groups',
    },
  ];
  selectValue: string = this.selectOptions[0].id;
  selectIntervalOptions: SelectOption[] = selectIntervalOptions;
  selectIntervalValue: any = this.selectIntervalOptions[0].id;
  selectFrequencyOptions: SelectOption[] = selectFrequencyOptions;
  selectFrequencyValue: string = this.selectFrequencyOptions[0].id;
  selectWeeklyOptions: SelectOption[] = selectWeeklyOptions;
  selectWeeklyValue: string = this.selectWeeklyOptions[0].id;
  selectMonthlyOptions: SelectOption[] = selectMonthlyOptions;
  selectMonthlyValue: string = this.selectMonthlyOptions[0].id;
  selectNsmMonthlyOptions: SelectOption[] = selectNsmMonthlyOptions;
  selectNsmMonthlyValue: string = this.selectNsmMonthlyOptions[0].id;
  selectTimeOptions: SelectOption[] = selectTimeOptions;
  selectTimeValue: string = this.selectTimeOptions[0].id;
  tabsProps = selectProductTabs;
  selectProductTab: string = this.tabsProps[0].tabId;
  selectReportPeriodOptions: SelectOption[] = selectReportPeriodOptions;
  selectReportPeriodValue: string = this.selectReportPeriodOptions[0].id;
  isClicked: boolean = false;
  regularValue: boolean = false;
  actionType: string = 'Email';
  editOrCreate: string = 'Create';
  emailBody: string = '';
  emailSubject: string = '';
  nsmScheduledData = _.cloneDeep(nsmScheduledPostData);
  editNsmData: any;
  editWirelessData: any;
  changeAmPm = '';
  editCcData: any;
  wirelessData: any = {};
  nsmArchiveEmail = [
    { name: 'Archive', selected: true },
    { name: 'Email', selected: false },
  ];
  wcmSession: any;
  wcmTenantId: string = '';
  isSelectAll:boolean = false;
  isSelectAllDisabled:boolean = false;
  /**
   * @desc Mapping dynamic component data
   * @param data Object contains data from dynamic component.
   */
  getApiData(data: any) {
    if (this.selectProductTab === 'firewallReport') {
      if (data[0].reportTypes && data[0].reportTypes.length !== 0) {
        this.mapNsmReportData(data);
      } else {
        this.selectReportContent();
      }
    } else if (this.selectProductTab === 'captureClientReport') {
      if (this.checkCcData(data) !== 0) {
        this.mapCcReportData(data);
      } else {
        this.selectReportContent();
      }
    } else {
      if (this.checkWcmData(data) !== 0) {
        this.mapWirelessData(data);
      } else {
        this.selectReportContent();
      }
    }
  }

  /**
   * @desc Checking that user must select least one value
   * @param data Object contains data from dynamic component.
   */
  checkWcmData(data: any): number {
    let count = 0;
    for (const val in data) {
      if (data[val]) {
        count += 1;
      }
    }
    return count;
  }

  checkCcData(data: any): number {
    let count = 0;
    data.map((entry: { name: string; content: string }, index: number) => {
      if (entry.content !== 'none' && index < 7) {
        count += 1;
      }
    });
    return count;
  }

  created() {
    this.initValidation();
  }

  closeModal() {
    this.$emit('closedModal');
  }

  validateName(name: string) {
    if (name.trim() === '') {
      return true;
    }
  }

  @Watch('tenantGroups', { immediate: true })
  fetchGroups() {
    this.selectOptions.splice(1, this.selectOptions.length);
    const newGroupOptions: SelectOption[] = this.tenantGroups.map(
      (group: { groupId: string; groupName: string; devices: any }) => {
        return {
          id: group.groupId,
          label: group.groupName,
        };
      },
    );
    this.selectOptions = [...this.selectOptions, ...newGroupOptions];
  }

  /**
   * @desc To add default value when modal will open
   */
  @Watch('openModal')
  changeValue() {
    const productDataGroupMapped: string[] = this.productList.map(
      (product: any) => {
        if (product === 'NGMGMT') {
          return 'firewallReport';
        }
        if (product === 'Capture Client') {
          return 'captureClientReport';
        }
        if (product === 'Wireless') {
          return 'wirelessReport';
        }
        return '';
      },
    );
    const activeProduct:string[] = [];
    this.tabsProps = this.tabsProps.map(
      (product) => {
        if (productDataGroupMapped.includes(product.tabId)) {
          activeProduct.push(product.tabId);
          return { ...product, disabled: false };
        }
        return { ...product, disabled: true };
      },
    );
    this.selectProductTab = activeProduct[0] || '';
    this.reportType =
      this.selectProductTab === 'firewallReport'
        ? 'scheduled_report'
        : 'ondemand_report';
    this.changeAmPm = '';
    this.getUtcTime();
    this.showMsg = false;
    this.showEmailMsg = false;
    this.showMailError = false;
    this.disableReportType = false;
    this.isSelectAll = false;
    this.display = this.openModal;
    this.selectValue = 'All groups';
    this.actionType = 'Email';
    this.emailAddress =
      localStorageKeeperService.retrieveJSON('currentUser').email || '';
    this.reportName = '';
    this.reportDescription = '';
    this.editOrCreate = 'Create';
    this.nsmArchiveEmail[1].selected = false;
    this.nsmArchiveEmail[0].selected = true;
    this.nsmScheduledData = _.cloneDeep(nsmScheduledPostData);
    this.selectFrequencyValue = 'daily';
    this.selectTimeValue = '0';
    this.emailSubject = '';
    this.emailBody = '';
    this.isSelectAllDisabled = false;
  }

  /**
   * @desc function will call when user clicks on edit option
   */
  @Watch('isReportEdit')
  setEditReportData() {
    if (this.isReportEdit) {
      this.editOrCreate = 'Edit';
      if (this.editReportData[1] === 'Capture Client') {
        this.selectProductTab = 'captureClientReport';
        this.editCcData = _.cloneDeep(this.editReportData[0]);
        this.selectFrequencyValue = this.editCcData.schedule;
        if (this.selectFrequencyValue === 'weekly') {
          this.selectWeeklyValue = `${this.editCcData.day}`;
        } else if (this.selectFrequencyValue === 'monthly') {
          this.selectMonthlyValue = `${this.editCcData.day}`;
        }
        this.selectTimeValue = `${this.editCcData.hour}`;
        this.emailAddress = this.editCcData.emails[0];
        this.reportName = this.editCcData.name;
      } else if (this.editReportData[0].productName === 'Wireless') {
        this.selectProductTab = 'wirelessReport';
        this.editWirelessData = _.cloneDeep(this.editReportData[0]);
        this.reportName = this.editWirelessData.report_name;
        this.selectFrequencyValue = this.editWirelessData.hasOwnProperty('config') &&
          this.editWirelessData.config.hasOwnProperty('period') &&
          this.editWirelessData.config.period === 'week' ? 'weekly' : 'daily';
        if (this.editWirelessData.hasOwnProperty('config') &&
          this.editWirelessData.config.hasOwnProperty('schedule')) {
          this.selectTimeValue =  this.editWirelessData.config.schedule.hasOwnProperty('hour') &&
            String(this.editWirelessData.config.schedule.hour) || '0';
          this.selectWeeklyValue =  this.editWirelessData.config.schedule.hasOwnProperty('week') &&
            String(this.editWirelessData.config.schedule.week) || '0';
          if (this.editWirelessData.config.schedule.hasOwnProperty('emails') &&
            this.editWirelessData.config.schedule.emails.length > 0) {
            this.emailAddress = this.editWirelessData?.config?.schedule?.emails[0];
          } else {
            this.emailAddress = localStorageKeeperService.retrieveJSON('currentUser').email || '';
          }
        }
      } else {
        this.editNsmData = _.cloneDeep(this.editReportData[0]);
        try {
          const deviceConfig =
            this.editNsmData &&
            this.editNsmData.deviceConfig &&
            this.editNsmData.deviceConfig.devices
              ? [...this.editNsmData.deviceConfig.devices]
              : [];
          if (deviceConfig.length !== 1) {
            this.selectValue = 'All groups';
          } else {
            this.selectValue =
              (deviceConfig[0].level === 'group' && deviceConfig[0].serial) ||
              'All groups';
          }
        } catch (error) {
          console.error('Failed to fetch device Group', error);
          this.selectValue = 'All groups';
        }
        this.selectProductTab = 'firewallReport';
        this.mapEditedNsmData();
        this.mapMailArchiveData();
      }
      this.isEditUnable = true;
      this.reportType = 'scheduled_report';
      this.disableReportType = true;
      this.tabsProps = this.disableProduct(this.tabsProps, true);
    }
  }

  /**
    @desc To enable/disable product tab
    @param tabProps Product tab data
    @param isSelected enable or disable
  */
  private disableProduct(tabsProps:any, isSelected:boolean) {
    return tabsProps.map(
      (product:any) => {
        return { ...product, disabled: isSelected };
      },
    );
  }

  changeProductTab() {
    if (this.selectProductTab === 'firewallReport') {
      this.reportType = 'scheduled_report';
    } else {
      this.reportType = 'ondemand_report';
    }
    this.nsmArchiveEmail = [
      { name: 'Archive', selected: true },
      { name: 'Email', selected: false },
    ];
    this.selectFrequencyValue = 'daily';
    this.showMsg = false;
    this.reportName = '';
    this.reportDescription = '';
    this.isSelectAll = false;
    this.isSelectAllDisabled = false;
  }

  fetchToken(token: string) {
    return sessionStorageKeeperService.retrieve(token) || '';
  }

  /**
    @desc API call for create reports
  */
  getReport(endpoint: string, dataSet: any, group: string) {
    unifiedInsightsApiService
      ?.getDataGroupApiWrapper(group)
      ?.createReport(endpoint,  dataSet, {})
      .then((response: any) => {
        this.isLoading = false;
        if (
          this.selectProductTab === 'firewallReport' &&
          response.status.info[0].level === 'error'
        ) {
          this.errorMessage(response.status.info[0].message);
        } else {
          this.closeModal();
          messageService.messageManager.showMessage(
            unifiedMessageContainer,
            this.editOrCreate === 'Create'
              ? this.$t('spog.unifiedInsights.reprAvailGen')
              .toString()
              : this.$t('spog.unifiedInsights.reprUpdtSucc')
              .toString(),
            'success',
          );
          this.$emit('actionPerformed', true);
        }
      })
      .catch((error: any) => {
        this.isLoading = false;
        const errorMsg = this.editOrCreate === 'Edit' ? 'update' : 'create';
        this.errorMessage(`Failed to ${errorMsg} a report`);
        console.error('Report API Error', error);
      });
  }

  /**
    @desc API call for create CC scheduled reports
  */
  createScheduleReport(
    endpoint: string,
    dataSet: any,
    token: string,
    url: string | undefined,
  ) {
    axios({
      method: 'post',
      url: `${url}${endpoint}`,
      data: dataSet,
      headers: { Authorization: token },
    })
      .then(() => {
        this.isLoading = false;
        this.closeModal();
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.editOrCreate === 'Create'
            ? this.$t('spog.unifiedInsights.reprAvailGen')
            .toString()
            : this.$t('spog.unifiedInsights.reprUpdtSucc')
            .toString(),
          'success',
        );
        this.$emit('actionPerformed', true);
      })
      .catch((error: any) => {
        this.isLoading = false;
        const errorMsg = this.editOrCreate === 'Edit' ? 'update' : 'create';
        this.errorMessage(`Failed to ${errorMsg} a report`);
        console.error('Report API Error', error);
      });
  }

  /**
    @desc API call for create wireless reports
  */
  createWnmReports(data: any) {
    wcmApiService
      ?.createReport(
        `/tenants/${this.wcmTenantId}/system/reports/tasks`,
        data,
      )
      .then(() => {
        this.isLoading = false;
        this.closeModal();
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.editOrCreate === 'Create'
            ? this.$t('spog.unifiedInsights.reprAvailGen')
            .toString()
            : this.$t('spog.unifiedInsights.reprUpdtSucc')
            .toString(),
          'success',
        );
        this.$emit('actionPerformed', true);
      })
      .catch((error: any) => {
        const errorMessage = error?.response?.data?.detailed_message || '';
        this.isLoading = false;
        this.errorMessage(errorMessage || 'Failed to create a report');
        console.error('Report API Error', error);
      });
  }

  editWNMReports(data: any, scheduleID: any) {
    wcmApiService
      ?.editReportData(
        `/tenants/${this.wcmTenantId}/system/reports/task/${scheduleID}`,
        data,
      )
      .then(() => {
        this.isLoading = false;
        this.closeModal();
        messageService.messageManager.showMessage(
          unifiedMessageContainer,
          this.$t('spog.unifiedInsights.reprUpdtSucc')
          .toString(),
          'success',
        );
        this.$emit('actionPerformed', true);
      })
      .catch((error: any) => {
        this.isLoading = false;
        this.errorMessage('Failed to edit a report');
        console.error('Report API Error', error);
      });
  }

  /**
    @desc This function will call when the user clicks on save button
  */
  onSave() {
    ccOnDemandPostData.nbItems = Number(this.selectIntervalValue.split('-')[0]) || 24;
    ccOnDemandPostData.frequency = this.selectIntervalValue.split('-')[1] || 'hourly';
    ccOnDemandPostData.emails = ccScheduledPostData.emails = [
      this.emailAddress,
    ];
    ccOnDemandPostData.name = this.reportName;
    ccScheduledPostData.name = this.reportName;
    this.isClicked = !this.isClicked;
    if (this.reportType === 'ondemand_report') {
      ccOnDemandPostData.action = this.actionType;
    }
  }

  private selectReportContent() {
    confirmService.confirm({
      message: this.$t('spog.unifiedInsights.selRepMsg')
      .toString(),
      title: this.$t('spog.unifiedInsights.timeFrameMsg')
      .toString(),
      status: 'informational',
      buttons: [
        {
          key: 'ok',
          name: this.$t('products.ok')
          .toString(),
          isDefault: true,
        },
      ],
    });
  }

  private errorMessage(msg: string) {
    confirmService.confirm({
      message: msg,
      title: this.$t('printProductDetails.error')
      .toString(),
      status: 'failed',
      buttons: [
        {
          key: 'ok',
          name: this.$t('products.ok')
          .toString(),
          isDefault: true,
        },
      ],
    });
  }

  /**
    @desc computed property to pass props in the dynamic component.
  */
  get componentProps() {
    const prop = {
      isClicked: this.isClicked,
      editReportData: this.editReportData[0],
      isReportEdit: this.isReportEdit,
      isModalClose: this.display,
      isSelectAll: this.isSelectAll,
    };
    return prop;
  }

  mapWirelessData(data: any) {
    this.wirelessData.name = this.reportName;
    const periodValue  = this.reportType === 'ondemand_report' ? this.selectReportPeriodValue : this.mapPeriodData(this.selectFrequencyValue);
    this.wirelessData.generate_from = this.reportType === 'ondemand_report' ? 'ondemand' : 'schedule';
    this.wirelessData.config = {
      option: { ...data },
      period: periodValue,
      schedule: {
        emails: [this.emailAddress],
        hour : Number(this.selectTimeValue),
        send_email : true,
        week : Number(this.selectWeeklyValue),
      },
    };
    this.wcmSession = sessionStorageKeeperService.retrieveJSON('wcmSession');
    if (
      this.wcmSession &&
      this.wcmSession.ssoKeys &&
      this.wcmSession.ssoKeys.tenants &&
      this.wcmSession.ssoKeys.tenants.length > 0
    ) {
      this.wcmTenantId = this.wcmSession.ssoKeys.tenants[0].tenant_id;
    }
    if (this.editOrCreate === 'Edit') {
      this.isLoading = true;
      const scheduleID = this.editReportData[0] && this.editReportData[0].id || '';
      this.editWNMReports(this.wirelessData, scheduleID);
    } else {
      if (this.reportType === 'ondemand_report' && this.totalWcmOnDemandReports >= 10) {
        confirmService.confirm({
          message: this.$t('spog.unifiedInsights.onDmdMsg')
          .toString(),
          title: this.$t('spog.unifiedInsights.timeFrameMsg')
          .toString(),
          status: 'informational',
          buttons: [
            {
              key: 'cancel',
              name: this.$t('common.cancel')
              .toString(),
              isDefault: false,
            }, {
              key: 'ok',
              name: this.$t('products.ok')
              .toString(),
              isDefault: true,
            },
          ],
        })
        .then((value: string) => {
          if (value === 'ok') {
            this.isLoading = true;
            this.createWnmReports(this.wirelessData);
          }
        });
      } else {
        this.isLoading = true;
        this.createWnmReports(this.wirelessData);
      }
    }
  }

  mapPeriodData(value: string) {
    const periodValue: any = {
      daily :'day',
      weekly: 'week',
      monthly : 'month' };
    return periodValue[value];
  }

  mapNsmReportData(data: any) {
    if (this.isReportEdit) {
      this.editNsmData.reportConfig.reportModules = data;
      this.editNsmData.moduleUnionId = data[0].id;
      this.mapNsmDevicesData(this.editNsmData);
      this.mapNsmReportSubData(this.editNsmData);
      this.mapNsmTaskConfig(this.editNsmData);
      this.mapNsmTimeData(this.editNsmData);
      this.isLoading = true;
      this.getReport('/reportconfig/taskconfig', this.editNsmData, 'firewall');
    } else {
      this.nsmScheduledData.reportConfig.reportModules = data;
      this.nsmScheduledData.moduleUnionId = data[0].id;
      this.mapNsmDevicesData(this.nsmScheduledData);
      this.mapNsmReportSubData(this.nsmScheduledData);
      this.mapNsmTaskConfig(this.nsmScheduledData);
      this.mapNsmTimeData(this.nsmScheduledData);
      this.isLoading = true;
      this.getReport(
        '/reportconfig/taskconfig',
        this.nsmScheduledData,
        'firewall',
      );
    }
  }

  mapNsmDevicesData(data: any) {
    if (this.selectValue === 'All groups') {
      // const devices: any = [];
      // const groupOption = this.selectOptions.slice(
      //   1,
      //   this.selectOptions.length,
      // );
      // groupOption.map((entry: any) => {
      //   devices.push({ level: 'group', serial: entry.id });
      // });
      const devices: any[] = [{ level:'tenant',
        serial: this.nsmTenentID,
      }];
      data.deviceConfig = { devices };
    } else {
      data.deviceConfig = {
        devices: [{ level: 'group', serial: this.selectValue }],
      };
    }
  }

  mapNsmReportSubData(data: any) {
    if (this.nsmArchiveEmail[0].selected && this.nsmArchiveEmail[1].selected) {
      emailConfig.subject = this.emailSubject;
      emailConfig.emailDestination = [this.emailAddress];
      emailConfig.body = this.emailBody;
      data.deliveryConfig.emailConfig = emailConfig;
      data.deliveryConfig.archiveConfig = archiveConfig;
      return;
    }
    if (this.nsmArchiveEmail[0].selected) {
      if (this.isReportEdit && data.deliveryConfig.emailConfig !== undefined) {
        delete data.deliveryConfig.emailConfig;
      }
      data.deliveryConfig.archiveConfig = archiveConfig;
      return;
    }
    if (this.nsmArchiveEmail[1].selected) {
      if (
        this.isReportEdit &&
        data.deliveryConfig.archiveConfig !== undefined
      ) {
        delete data.deliveryConfig.archiveConfig;
      }
      emailConfig.subject = this.emailSubject;
      emailConfig.emailDestination = [this.emailAddress];
      emailConfig.body = this.emailBody;
      data.deliveryConfig.emailConfig = emailConfig;
      return;
    }
  }
  mapNsmTaskConfig(data: any) {
    data.taskConfig.taskDesc = this.reportDescription ? this.reportDescription : '';
  }
  mapMailArchiveData() {
    this.nsmArchiveEmail[0].selected = false;
    this.nsmArchiveEmail[1].selected = false;
    if (
      this.editNsmData.deliveryConfig.emailConfig &&
      this.editNsmData.deliveryConfig.archiveConfig
    ) {
      this.nsmArchiveEmail[0].selected = true;
      this.nsmArchiveEmail[1].selected = true;
      this.emailAddress = this.editNsmData.deliveryConfig.emailConfig.emailDestination[0];
      this.emailSubject = this.editNsmData.deliveryConfig.emailConfig.subject;
      this.emailBody = this.editNsmData.deliveryConfig.emailConfig.body;
      return;
    }
    if (this.editNsmData.deliveryConfig.archiveConfig) {
      this.nsmArchiveEmail[0].selected = true;
      return;
    }
    if (this.editNsmData.deliveryConfig.emailConfig) {
      this.nsmArchiveEmail[1].selected = true;
      this.emailAddress = this.editNsmData.deliveryConfig.emailConfig.emailDestination[0];
      this.emailSubject = this.editNsmData.deliveryConfig.emailConfig.subject;
      this.emailBody = this.editNsmData.deliveryConfig.emailConfig.body;
      return;
    }
  }

  mapNsmTimeData(data: any) {
    if (this.selectFrequencyValue === 'weekly') {
      if (data.deliveryConfig.dayOfMonth !== undefined) {
        delete data.deliveryConfig.dayOfMonth;
      }
      data.intervalType = 1;
      data.deliveryConfig.dayOfWeek = Number(this.selectWeeklyValue);
    } else if (this.selectFrequencyValue === 'monthly') {
      data.intervalType = 2;
      if (data.deliveryConfig.dayOfWeek !== undefined) {
        delete data.deliveryConfig.dayOfWeek;
      }
      data.deliveryConfig.dayOfMonth = Number(this.selectNsmMonthlyValue);
    } else if (this.selectFrequencyValue === 'weekly') {
      if (data.deliveryConfig.dayOfWeek !== undefined) {
        delete data.deliveryConfig.dayOfWeek;
      }
      if (data.deliveryConfig.dayOfMonth !== undefined) {
        delete data.deliveryConfig.dayOfMonth;
      }
    }
    data.deliveryConfig.scheduleHour = Number(this.selectTimeValue);
    data.taskName = this.reportName;
  }

  mapEditedNsmData() {
    if (this.editNsmData.intervalType === 1) {
      this.selectWeeklyValue = String(
        this.editNsmData.deliveryConfig.dayOfWeek,
      );
      this.selectFrequencyValue = 'weekly';
    } else if (this.editNsmData.intervalType === 2) {
      this.selectNsmMonthlyValue = String(
        this.editNsmData.deliveryConfig.dayOfMonth,
      );
      this.selectFrequencyValue = 'monthly';
    } else {
      this.selectFrequencyValue = 'daily';
    }
    this.selectTimeValue = String(this.editNsmData.deliveryConfig.scheduleHour);
    this.reportName = this.editNsmData.taskName;
    this.reportDescription = this.editNsmData.taskConfig &&
      this.editNsmData.taskConfig.hasOwnProperty('taskDesc') ?
      this.editNsmData.taskConfig.taskDesc : '';
  }

  mapCcReportData(data: any) {
    const token = this.fetchToken('ccToken');
    if (this.reportType === 'ondemand_report') {
      ccOnDemandPostData.sections = data;
      this.isLoading = true;
      this.getReport('/report', ccOnDemandPostData, 'capture client');
    } else {
      if (this.isReportEdit) {
        this.editCcData.name = this.reportName;
        this.mapScheduledData(data, this.editCcData);
        this.mapTimeValue(this.editCcData);
        this.editCcData.schedule = this.selectFrequencyValue;
        this.isLoading = true;
        this.createScheduleReport(
          '/report/scheduledReport',
          this.editCcData,
          token,
          `${this.ccBaseUrl}/api`,
        );
      } else {
        this.mapScheduledData(data, ccScheduledPostData);
        this.mapTimeValue(ccScheduledPostData);
        ccScheduledPostData.schedule = this.selectFrequencyValue;
        this.isLoading = true;
        this.createScheduleReport(
          '/report/scheduledReport',
          ccScheduledPostData,
          token,
          `${this.ccBaseUrl}/api`,
        );
      }
    }
  }

  /**
    @desc To enable/disable email field
  */
  @Watch('nsmArchiveEmail', { immediate: true, deep: true })
  @Watch('selectProductTab')
  @Watch('actionType')
  @Watch('reportType')
  disabledField() {
    this.disabledEmailField = false;
    if (
      (this.selectProductTab === 'captureClientReport' &&
        this.actionType === 'Download' &&
        this.reportType === 'ondemand_report') ||
      (this.selectProductTab === 'firewallReport' &&
        !this.nsmArchiveEmail[1].selected) ||
      (this.selectProductTab === 'wirelessReport' &&
        this.reportType === 'ondemand_report')
    ) {
      this.disabledEmailField = true;
    }
  }

  /**
    @desc Validation for modal popup will be initialized by created lifecycle hook.
  */
  initValidation() {
    const validationConfig: ValidationGroupConfig[] = [
      {
        context: this,
        name: 'default',
        watcher: this.$watch,
        errorsObj: this.errorsObj,
        items: [
          {
            path: 'emailAddress',
            type: validationType.emailAddress,
            instant: true,
            required: true,
          },
        ],
      },
    ];
    validationService.validator.init(validationConfig);
  }

  /**
    @desc To enable/disable save button
  */
  @Watch('disabledEmailField')
  @Watch('emailSubject')
  @Watch('nsmArchiveEmail', { deep: true })
  @Watch('errorsObj.emailAddress')
  @Watch('reportName', { immediate: true })
  changeSaveState() {
    if (
      this.reportName.trim() === '' ||
      (this.errorsObj.emailAddress !== undefined && !this.disabledEmailField) ||
      (this.nsmArchiveEmail[1].selected && this.emailSubject.trim() === '') ||
      (this.selectProductTab === 'firewallReport' &&
        !this.nsmArchiveEmail[1].selected &&
        !this.nsmArchiveEmail[0].selected)
    ) {
      this.disableSaveButton = true;
    } else {
      this.disableSaveButton = false;
    }
  }

  convertToBool(val: string): boolean {
    if (val === 'false') {
      return false;
    }
    return true;
  }

  mapTimeValue(toData: any) {
    if (this.selectFrequencyValue === 'weekly') {
      toData.day = this.selectWeeklyValue;
    } else if (this.selectFrequencyValue === 'monthly') {
      toData.day = this.selectMonthlyValue;
    }
    toData.hour = Number(this.selectTimeValue);
  }

  mapScheduledData(fromData: any, toData: any) {
    toData.activitiesSection = fromData[3].content;
    toData.applicationsSection = fromData[5].content;
    toData.atpSection = fromData[1].content;
    toData.devicesSection = fromData[2].content;
    toData.includeAtpHistory = this.convertToBool(fromData[8].content);
    toData.includeAtpList = this.convertToBool(fromData[11].content);
    toData.includeDeviceHistory = this.convertToBool(fromData[9].content);
    toData.includeDeviceList = this.convertToBool(fromData[12].content);
    toData.includeRiskyAppsList = this.convertToBool(fromData[15].content);
    toData.includeRiskyDevicesList = this.convertToBool(fromData[14].content);
    toData.includeTenantList = this.convertToBool(fromData[13].content);
    toData.includeThreatHistory = this.convertToBool(fromData[7].content);
    toData.includeThreatList = this.convertToBool(fromData[10].content);
    toData.tenantsSection = fromData[6].content;
    toData.threatsSection = fromData[0].content;
    toData.webProtectionSection = fromData[4].content;
  }

  setHours(val: number): string | number {
    let setHours: string | number = val;
    if (val > 12) {
      if (val % 12 === 0) {
        setHours = 12;
      } else {
        setHours = val % 12;
      }
    }
    setHours = setHours > 9 ? `${setHours}` : `0${setHours}`;
    return setHours;
  }

  getAmOrPm(hours: number, index: number) {
    let hourString = '';
    index > 0 && (hourString = String(this.selectTimeOptions[index - 1].label));
    if (
      hours % 12 === 0 &&
      hourString.includes('PM') &&
      !hourString.includes('AM') &&
      index > 1
    ) {
      this.changeAmPm = 'AM';
    }
    if (
      hours % 12 === 0 &&
      hourString.includes('AM') &&
      !hourString.includes('PM') &&
      index > 1
    ) {
      this.changeAmPm = 'PM';
    }
    if (hours > 12 && hours % 12 !== 0 && this.changeAmPm === '') {
      return 'PM';
    }
    if ((hours <= 12 || hours % 12 === 0) && this.changeAmPm === '') {
      return 'AM';
    }
    return this.changeAmPm;
  }

  getTime(hour: number, minute: number) {
    this.selectTimeOptions.map((entry: any) => {
      const idx = Number(entry.id);
      const minutes = minute === 30 ? `${minute}` : '00';
      const labels = `${this.setHours(hour + idx)}:${minutes} ${this.getAmOrPm(
        hour + idx,
        idx,
      )} - ${this.setHours(hour + idx + 1)}:${minutes} ${this.getAmOrPm(
        hour + idx + 1,
        idx,
      )}`;
      entry.label = labels;
    });
  }

  /**
   * @desc To convert time to UTC time format.
   */
  getUtcTime() {
    const time = new Date().getTimezoneOffset();
    let hours;
    let minutes;
    if (time < 0) {
      hours = -_.ceil(time / 60);
      minutes = -(time % 60);
    } else {
      hours = 24 - _.ceil(time / 60);
      hours === 0 && (hours = 12);
      minutes = time % 60;
    }
    this.getTime(hours, minutes);
  }
}
